import OrderList from "./lists/OrderList";
const Orders = () => {
  return (<>
  <OrderList>
  </OrderList>
  </>);
};

export default Orders;
